// AntdDatePickerField.js
import { DatePicker } from "antd";

const AntdDatePickerField = ({ field, form, ...props }) => (
  <DatePicker
    {...props}
    value={field.value}
    format="DD MMM YYYY"
    className="w-100"
    dropdownStyle={{ zIndex: 9999 }}
    style={{ width: "100%" }}
    onChange={(date) => form.setFieldValue(field.name, date)}
    onBlur={() => form.setFieldTouched(field.name, true)}
    getPopupContainer={(triggerNode) => triggerNode.parentNode}
  />
);
export default AntdDatePickerField;
